import {Card, FC, PropsWithChildren} from 'external/react'

const BasicLayout: FC<PropsWithChildren> = props => {

    const {children} = props

    return (
		<div className='container'>
			<div className='row mt-5 mb-5'>
				<div className='col-12-md'>
					<Card className='shadow card--card'>
                        {children} 
                    </Card>
                </div>
            </div>
        </div>
    )
}

export {BasicLayout as default}